import { JoinChannel, OpenSocket } from 'api/socket'
import { chatEvents, presenceEvents, userEvents } from 'modules/events'
import { Socket } from 'phoenix'
import { SocketAuthentication } from 'types/auth'
import { error } from 'utils'

type ConnectToSocketArgs = {
  session_token: string,
  org_id: number,
  socketCluster: string,
  ip: string
}

type ConnectToChannelArgs = {
  socket: Socket,
  channelEvents: string,
  socketAuth: SocketAuthentication,
  channelName: string,
  orgId: number
}

export const SOCKET_CLUSTER = Object.freeze({
  CHAT: 'chat',
  USER: 'user',
  PRESENCE: 'presence',
  VISITOR_PRESENCE: 'visitor_presence'
})

export const SOCKET_CHANNELS = Object.freeze({
  CHAT: 'chat',
  USER: 'user',
  ORG_PUBLIC: 'live',
  LIVE: 'live'
})

export const CHANNEL_EVENTS = Object.freeze({
  CHAT: 'chat',
  USER: 'user',
  PRESENCE: 'presence'
})


export const connectToSocket = async ({
  session_token,
  org_id,
  socketCluster,
  ip
}: ConnectToSocketArgs) => {
  const socketPromise = new Promise<Socket>(async (resolve, reject) => {
    const socket = await OpenSocket({ session_token, org_id, socketCluster, ip })

    if(!!socket) {
      return resolve(socket)
    } else {
      return reject('could not connect')
    }
  })
  return socketPromise
}

export const connectToChannel = async ({
  socket,
  socketAuth,
  channelEvents,
  channelName,
  orgId,
}: ConnectToChannelArgs) => {
  try {
    const channel = await JoinChannel({
      channelName: _resolveChannelName(channelName, socketAuth.user_id, orgId),
      socket,
      events: _resolveChannelEvents(channelEvents)
    })
    return channel

  } catch (err) {
    error(new Error(err))
  }
}

const _resolveChannelName = (channelName: string, userId: string, orgId: number) => {
  switch(channelName) {
    case SOCKET_CHANNELS.USER:
    case SOCKET_CHANNELS.CHAT:
      return `${channelName}:${userId}`
    case SOCKET_CHANNELS.LIVE:
      return `${channelName}:${orgId}`
    default: return ''
  }
}

const _resolveChannelEvents = (events: string) => {
  switch(events) {
    case CHANNEL_EVENTS.CHAT: return chatEvents
    case CHANNEL_EVENTS.USER: return userEvents
    case CHANNEL_EVENTS.PRESENCE: return presenceEvents
    default: return []
  }
}
